<template>
  <a
    :class="[{ active: !!getVideoCodes(featuredMatches, imgParams) }]"
    :href="matchUrl(featuredMatches, imgParams)"
    v-if="withThumbnail"
  >
    <!-- anchor for trending image -->
    <img
      :src="match_image(featuredMatches, imgParams)"
      :alt="featuredMatches.name"
      importance="high"
    />
  </a>
  <article class="article-item home-featured" v-else>
    <div class="article-wrap">
      <div class="article-thumbnail">
        <div class="img-box">
          <a
            :class="[{ active: !!getVideoCodes(featuredMatches, imgParams) }]"
            :href="matchUrl(featuredMatches, imgParams)"
          >
            <!-- anchor for featured image -->
            <img
              v-if="lazyImgType"
              class="lazy"
              :src="defaultImg[lazyImgType]"
              :data-src="match_image(featuredMatches, imgParams)"
              :alt="featuredMatches.name"
            />
            <img
              v-else
              :src="match_image(featuredMatches, imgParams)"
              :alt="featuredMatches.name"
            />
          </a>
        </div>
      </div>
      <div class="article-content">
        <a
          :href="matchUrl(featuredMatches, imgParams)"
        >
          <div class="match-item">
            <div
              class="match-date"
              v-html="getDateTimeString(featuredMatches)"
            />
            <div class="match-data">
              <div class="team team-A">
                <div class="team-name">
                  <p class="article-title">{{ generateHeadline() }}</p>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </article>
</template>

<script>
import {
  fetchMatchCodeFromString,
  formatFullUrl,
  getDateString,
  getMatchInfoTitle,
  urlCorrections,
} from "../../assets/js/common";
import {
  CFG_MODULES,
  CFG_WIDGET_URL_BASE,
  CFG_HEAD_TO_HEAD_IMAGE_FROM,
} from "../../assets/js/config";
export default {
  props: [
    "featuredMatches",
    "translations",
    "imgParams",
    "showDreamTeamImg",
    "showYoutubeThumbnail",
    "withThumbnail",
    "pageHeadKey",
    "lazyImgType",
  ],
  data() {
    return {
      defaultImg: {
        "square": "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-square.png",
        "rect": "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-rect.png"
      },
      listingModules: {
        contestMatchesListHeading: CFG_MODULES["GAME_PLAN"],
        lineupMatchesListHeading: CFG_MODULES["LINEUP"],
        matchTipsMatchesListHeading: CFG_MODULES["MATCH_INFO"],
      },
    };
  },
  methods: {
    getDateTimeString(featuredMatches) {
      let dateString = `${getDateString(
        featuredMatches.start_date,
        "day"
      )}<sup>${getDateString(
        featuredMatches.start_date,
        "abb"
      )}</sup> ${getDateString(
        featuredMatches.start_date,
        "month"
      )} ${getDateString(featuredMatches.start_date, "year")}`;

      if(featuredMatches.is_live_now) {
        dateString = `${dateString} <span class="live_match" style="color: #a12f2f; border: 1px solid; padding: 2px;"><strong>LIVE</strong></span>`;
      } else {
        dateString = `${dateString} | ${getDateString(featuredMatches.start_date, "time")}`;
      }
      return dateString;
    },
    generateHeadline() {
      let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hi/");
      let transObj = this.translations.match_tips_headline;
      if(this.featuredMatches.is_live_now) {
        transObj = this.translations[`scorecard_headline_live_${this.featuredMatches.sport_id}`];
      }
      return getMatchInfoTitle(
        this.featuredMatches,
        transObj,
        true,
        isHindi
      );
    },
    getVideoCodes(match, imgParams) {
      function isJson(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
      function getJSON(text) {
        try {
          return JSON.parse(text);
        } catch (e) {
          console.log("JSON Parsing Exception", e);
        }
      }

      let img = "";
      let { videos } = match;
      //  let videos = '{"ndtv":"S2aCjAjFl2s","fg":"S2aCjAjFl2s"}';
      if (videos) {
        if (isJson(videos)) {
          let { fg } = getJSON(videos);
          if(fg) {
            img = `https://www.fantasygully.com/ext-img/i.ytimg.com/vi/${fg}/maxresdefault.jpg${imgParams}`;
          }
        }
      }
      return img;
    },
    match_image(match, imgParams) {
      let mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/16_9_Match-Tips.png${imgParams}`;
      if (match) {
        let youtubeImg = this.getVideoCodes(match, imgParams);
        if (this.showDreamTeamImg && match.dream_team_image_id) {
          mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/article-images/${match.dream_team_image_id}${imgParams}`;
        } else if (this.showYoutubeThumbnail && youtubeImg) {
          mImgUrl = youtubeImg;
        } else {
          let startDate = match.match_start_date || match.start_date;
          let show_htoh_image =
            new Date(CFG_HEAD_TO_HEAD_IMAGE_FROM) - new Date(startDate) < 0;
          if (show_htoh_image) {
            let str = match.url || match.code;
            let code = fetchMatchCodeFromString(str);
            let templateFolder = match.image_template_id
              ? match.image_template_id
              : "match-images";
            mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/${templateFolder}/${code}.jpg${imgParams}`;
          }
        }
      }
      return mImgUrl;
    },
    matchUrl(obj, imgParams) {
      let hiUrl = this.$route && this.$route.path && this.$route.path.includes("/hi/") ? "/hi" : "";
      let url = "";
      if (obj.url) {
        url = obj.url;
        let moduleObj = this.listingModules[this.pageHeadKey];
        if(obj.is_live_now) {
          moduleObj = CFG_MODULES["SCORECARD"];
        }
        if (moduleObj && moduleObj.route) {
          url = url.replace(
            "match-tips-predictions/",
            `${moduleObj.route}`
          );
        }
        url = `${hiUrl}${url}`;
      } else {
        let basePage = this.listingModules[this.pageHeadKey].route;
        if(obj.is_live_now) {
          basePage = CFG_MODULES["SCORECARD"].route;
        }
        let lang = this.$route && this.$route.path && this.$route.path.includes("/hi/") ? "hi" : "en";
        url = formatFullUrl(obj, basePage, lang);
      }

      // if(this.listingModules && this.listingModules[this.pageHeadKey] && this.listingModules[this.pageHeadKey].route && this.listingModules[this.pageHeadKey].route === this.listingModules['matchTipsMatchesListHeading'].route){
      //   let youtubeImg = this.getVideoCodes(obj, imgParams);
      //   if(this.showYoutubeThumbnail && youtubeImg) {
      //     url = `${url}#video`;
      //   }
      // }

      return urlCorrections(url);
    },
  },
};
</script>
